export default __webpack_public_path__ + "static/media/el3.85a86535.svg";